import { useLocalStorage } from 'react-use';

/**
 * Persists the "read" state of the announcement banner.
 *
 * We store only the id of the LAST dismissed banner under a single key, rather
 * than one key per banner. This bounds LocalStorage to exactly one entry (no
 * accumulation over time) and still gives the "new banner overrides the old
 * dismissal" behaviour for free: when the backend serves a different `_id`, the
 * stored id no longer matches and the banner shows again.
 *
 * `useLocalStorage` (react-use) handles SSR and storage errors internally, so no
 * manual `window` guard / try-catch is needed here.
 */
const STORAGE_KEY = 'dismissed_announcement_banner';

export interface UseBannerDismissalResult {
  isDismissed: boolean;
  dismiss: () => void;
}

export const useBannerDismissal = (bannerId: string | undefined): UseBannerDismissalResult => {
  const [dismissedBannerId, setDismissedBannerId] = useLocalStorage<string>(STORAGE_KEY);

  return {
    isDismissed: !!bannerId && dismissedBannerId === bannerId,
    dismiss: () => {
      if (bannerId) setDismissedBannerId(bannerId);
    },
  };
};
